import { LiveSearchMetadataWebComponent } from './component/LiveSearchMetadataWebComponent';
import { WEB_COMPONENT_LIVE_SEARCH_METADATA } from '../../../webcomponents.constants';

export { LiveSearchMetadataWebComponent };

window.customElements.define(WEB_COMPONENT_LIVE_SEARCH_METADATA, LiveSearchMetadataWebComponent);
